import React from 'react';
import './ContactScreen.css';

const ContactScreen = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="hero">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you!</p>
        <p className="hero-text">We value our customers..</p>
      </section>

      {/* Contact*/}
      <section className="contact-section">
        {/* Left Side */}
        <div className="left-column">
          <div className="contact-info">
            <p><i className="fas fa-map-marker-alt"></i> Plot No. 369, Near Punjab National Bank, Industrial Area, Phase II, Chandigarh</p>
            <p><a href="https://wa.me/9814067069" target="_blank" rel="noreferrer"><i className="fas fa-phone-alt"></i> +91 9814067069</a></p>
            <p><a href="mailto:shaganarts@gmail.com"><i className="fas fa-envelope"></i> shaganarts@gmail.com</a></p>
            <p><i className="fas fa-info-circle"></i> GST No: 03DKZPS4497D1ZF</p>
          </div>
        </div>

        {/* Right Side */}
        <div className="right-column">
          <section className="branch-section">
            <h3>Branches</h3>
            <ul className="branch-list">
              <li><strong>Chandigarh</strong></li>
              <li><strong>Rajpura</strong></li>
              <li><strong>Ghanaur</strong></li>
            </ul>
          </section>
        </div>
      </section>
    </div>
  );
};

export default ContactScreen;